import { EKitchenBarMode } from "../../Enum/EKitchenBarMode"
import { EOrderCurrentStatus } from "../../Enum/EOrderCurrentStatus"
import { EOrderStatusType } from "../../Enum/EOrderStatus"
import { OrderEntity } from "../../Objects/Order/OrderEntity"

export type KitchenBarStation = "KITCHEN" | "BAR"

export const getKitchenBarStationItems = (
  order: OrderEntity,
  station: KitchenBarStation,
  kitchenBarMode: EKitchenBarMode,
) => {
  if (kitchenBarMode !== EKitchenBarMode.Separated) {
    return order.getAllGenericFoods()
  }

  return station === "BAR" ? order.orderDrinks : order.orderMeals
}

export const countOpenKitchenBarOrders = (
  orders: OrderEntity[],
  station: KitchenBarStation,
  kitchenBarMode: EKitchenBarMode,
) => {
  return orders.filter((order) => {
    if (order.eOrderStatusType === EOrderStatusType.Delivered) {
      return false
    }

    const stationItems = getKitchenBarStationItems(order, station, kitchenBarMode)

    return stationItems.some((item) => item.currentStatus !== EOrderCurrentStatus.Closed)
  }).length
}

const getOrderDateKey = (value: string) => {
  return value.split("T")[0]?.split(" ")[0] ?? ""
}

const getLocalDateKey = (value: Date) => {
  const year = value.getFullYear()
  const month = `${value.getMonth() + 1}`.padStart(2, "0")
  const day = `${value.getDate()}`.padStart(2, "0")

  return `${year}-${month}-${day}`
}

const isDelayedOpenOrder = (order: OrderEntity, currentDateKey: string) => {
  const orderDateKey = getOrderDateKey(order.date)

  if (!orderDateKey || orderDateKey >= currentDateKey || order.eOrderStatusType === EOrderStatusType.Delivered) {
    return false
  }

  return order.getAllGenericFoods().some((item) => item.currentStatus !== EOrderCurrentStatus.Closed)
}

export const countDelayedOpenOrders = (orders: OrderEntity[], currentDate: Date) => {
  const currentDateKey = getLocalDateKey(currentDate)

  return orders.filter((order) => isDelayedOpenOrder(order, currentDateKey)).length
}

export const countDelayedKitchenBarOrders = (
  orders: OrderEntity[],
  station: KitchenBarStation,
  kitchenBarMode: EKitchenBarMode,
  currentDate: Date,
) => {
  const currentDateKey = getLocalDateKey(currentDate)

  return orders.filter((order) => {
    const orderDateKey = getOrderDateKey(order.date)

    if (!orderDateKey || orderDateKey >= currentDateKey || order.eOrderStatusType === EOrderStatusType.Delivered) {
      return false
    }

    const stationItems = getKitchenBarStationItems(order, station, kitchenBarMode)

    return stationItems.some((item) => item.currentStatus !== EOrderCurrentStatus.Closed)
  }).length
}
